import { Text } from '@hopin-team/ui-text';
import React from 'react';

import { FullHeight } from '../../shared.styles';
import { Container } from './user-blocked-styles';

export const UserBlocked = () => {
  return (
    <FullHeight data-testid="already-bought-tickets-step">
      <Container>
        <Text pattern="headingThree" mb={3}>
          Sorry, looks like you can’t buy tickets to this event.
        </Text>
      </Container>
    </FullHeight>
  );
};
